import { IModalConfirmRef } from 'components/Modal/ModalConfirm';
import appointmentActions from 'features/appointment/services/actions';
import { CALENDAR_VIEW_TYPE } from 'features/appointment/services/constants';
import appointmentSelectors from 'features/appointment/services/selectors';
import {
  ICalendarHeader,
  ICalendarItemData,
  ICalendarSchema,
} from 'features/appointment/services/types/calendar';
import { IDateRangeItem } from 'features/appointment/utils/getRangeDates';
import moment from 'moment';
import React, { useCallback, useMemo } from 'react';
import { IStaffItemData } from 'services/shop/types/staff';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import { momentTimezone } from 'utils/time';
const ButtonAddMinus = styled.button`
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  position: absolute;
  right: 6.333px;
  border-radius: 4px;
  background: #e4f4f6;
  img {
    width: 32px;
    height: 32px;
  }

  &:hover,
  &:active {
    background: #eee;
  }
`;

export const modalConfirmRef = React.createRef<IModalConfirmRef>();
type Props = {
  modal?: boolean;
};
const useCalendarFilter = ({ modal }: Props): ICalendarSchema => {
  const distanceTimeline = appointmentSelectors.getDistanceTimeline();
  const typeView = appointmentSelectors.getViewType();
  const dateRangeList = appointmentSelectors.getDateRangeList();
  const staffListStore = appointmentSelectors.getListStaffAvailableBooking();
  const staffPage = appointmentSelectors.getStaffPage();
  const staffLimit = appointmentSelectors.getStaffLimit();
  const staffFilter = appointmentSelectors.staffFilter();

  const staffList = staffListStore;

  const move = (array: IStaffItemData[], from: number, to: number): IStaffItemData[] => {
    const copy = [...array];
    const [item] = copy.splice(from, 1);
    copy.splice(to, 0, item);
    return copy;
  };

  const moveSelectedToSecond = (
    staffList: IStaffItemData[],
    objSelected: IStaffItemData | null
  ): IStaffItemData[] => {
    if (!objSelected) return staffList;

    const currentIndex = staffList.findIndex((i) => i.id === objSelected.id);
    if (currentIndex === -1) return staffList;
    const anyBodyIndex = staffList.findIndex((i) => i.anyBody);
    if (anyBodyIndex !== -1) {
      const newList = move(staffList, anyBodyIndex, 0);
      const newSelectedIndex = newList.findIndex((i) => i.id === objSelected.id);
      return move(newList, newSelectedIndex, 1);
    }
    return move(staffList, currentIndex, 0);
  };

  // const staffList = useMemo(() => {
  //   const limit = staffLimit;
  //   if (modal) return staffListStore.filter(o => !o.anyBody);
  //   return _(staffListStore)
  //     .drop((staffPage - 1) * limit)
  //     .take(limit)
  //     .value();
  // }, [staffPage, staffListStore, staffLimit, modal]);

  const headers = useMemo(() => {
    if (typeView === CALENDAR_VIEW_TYPE.WEEK_VIEW) {
      return dateRangeList.map((item) => {
        const _date = moment(item.value);
        const result: ICalendarHeader = {
          id: item.id,
          value: _date,
          label: _date.format('DD.MM'),
          type: 'date',
          anybody: false,
          modal,
        };
        return result;
      });
    }

    if (typeView === CALENDAR_VIEW_TYPE.DAY_VIEW) {
      const firstAnybody = staffListStore.find((o) => o.anyBody);
      const updatedList = moveSelectedToSecond(staffList, staffFilter);
      return updatedList.map((item) => {
        const result: ICalendarHeader = {
          id: item.id,
          value: item.id,
          label: item.firstName,
          type: 'staff',
          url: item.urlImage,
          anybody: !!item.anyBody,
          addAnybody: firstAnybody?.id === item.id,
          minusAnybody: !!item.anyBody,
          modal,
          color: item.color || '',
          workingTime: item.timeSchedule ? item.timeSchedule : undefined,
        };
        return result;
      });
    }
    return [];
  }, [typeView, dateRangeList, staffList, modal, staffFilter]);

  const filterAppointments = useCallback(
    (order: ICalendarItemData, _col: ICalendarHeader<any>) => {
      if (typeView === CALENDAR_VIEW_TYPE.WEEK_VIEW) {
        const col = _col as ICalendarHeader<IDateRangeItem['value']>;
        return momentTimezone(order.startTime).isSame(col?.value, 'day');
      }

      if (typeView === CALENDAR_VIEW_TYPE.DAY_VIEW) {
        const col = _col as ICalendarHeader<any>;
        // if (col.id === SYSTEM_VARIABLES.UNASSIGNED) {
        //   if (order.book_assignment_services.length === 0) return true;
        //   else return !!order.book_assignment_services.find(service => !service?.assigned_employee || isEmpty(service?.assigned_employee) || !service?.assigned_employee?.employee);
        // }
        return order.staffId === col.id;
      }
      return false;
    },
    [typeView]
  );

  return {
    distanceTimeline,
    headers,
    typeView,
    filterAppointments,
    timeHourEnd: 22,
    timeHourStart: 8,
    timeMinuteEnd: 0,
    timeMinuteStart: 0,
    staffLimit,
    displayPagingSchedule: false,
  };
};

export default useCalendarFilter;
